(() => {
  'use strict';
  // Compatibility shim. Global gallery v8 owns initialisation and Shopify section lifecycle.
  window.__serranoVariantTileCarouselLoader = 'gallery-v8-owned';
})();
